// @ts-nocheck
import { useState } from 'react';
import MainContainer from '../../ui_components/MainContainer';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import { LoadingState } from '../../stats_components/LoadingState';
import { useLoaderData } from 'react-router-dom';
import RenderAllListPpvDescription from './RenderListPpv/RenderAllListPpvDescription';
import RenderByYearAllListPpv from './RenderListPpv/RenderByYearAllListPpv';

const ListSelectionButtons = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
    padding: 10px;
`;

const ButtonSelectionMainFilter = styled.div `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 33.33%;
    padding: 10px;
    border: 1px solid black;
    border-radius: 5px;
    background-color: ${colors.bgColorBlack};
    color: white;

    &.selected {
        background-color: ${colors.bgColorBordeaux};
    }
`;


function ListPpvsMobile() {
    const [responseData, setResponseData] = useState(useLoaderData());
    const [selectedFilter, setSelectedFilter] = useState('ppv');
    const [isLoading, setIsLoading] = useState(false);

    const listPpv = responseData.listPpv.data;
    const listPpvByYear = responseData.listPpvByYear;

    // Funzione per selezionare il filtro
    function handleSelectedFilter(filter) {
        setSelectedFilter(filter);
    }

    // In loading
    if(isLoading) {
        return <LoadingState />;
    }

    return (
        <MainContainer isMobile={true}>
            <ListSelectionButtons className='list-selection-buttons'>

                <ButtonSelectionMainFilter 
                    className={`button-selection-main-filter ppv ${selectedFilter === 'ppv' ? 'selected' : ''}`}
                    onClick={() => handleSelectedFilter('ppv')}
                >
                    PPV
                </ButtonSelectionMainFilter>

                <ButtonSelectionMainFilter 
                    className={`button-selection-main-filter year ${selectedFilter === 'year' ? 'selected' : ''}`}
                    onClick={() => handleSelectedFilter('year')}
                >
                    ANNO
                </ButtonSelectionMainFilter>

            </ListSelectionButtons>

            {/* Lista tutti ppv description */}
            {selectedFilter === 'ppv' && <RenderAllListPpvDescription listPpv={listPpv} />}

            {/* Lista tutti ppv by year */}
            {selectedFilter === 'year' && <RenderByYearAllListPpv listPpvByYear={listPpvByYear} />}

        </MainContainer>
    )
}

export default ListPpvsMobile;